export default __webpack_public_path__ + "static/media/cain.31a9a00c.jpg";